var render = function render(){var _vm=this,_c=_vm._self._c;return _c('connection-failure-base',{staticClass:"consent-failure",attrs:{"close-action":_vm.closeAction,"buttons":_vm.buttons},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',[_vm._v("החיבור לא הצליח,")]),_vm._v(" "),_c('div',[_vm._v("אפשר לנסות שוב!")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }